import { Component, OnInit, Input } from "@angular/core";

import { DebuggerService } from "../services/debugger.service";
import { BlocksService } from "../services/blocks.service";
import { GridService } from "../services/grid.service";

import { AppComponent } from "./app.component";
import { CanvasComponent } from "./canvas.component";
import { InputComponent } from "./input.component";
import { InterpreterService } from "app/services/interpreter.service";
import { CanvasActionSet } from "app/actionSets/canvasActionSet";
import { BluetoothService } from "app/services/bluetooth.service";
import { CommandsService } from "app/services/commands.service";
import { CanvasService } from "app/services/canvas.service";
import { RootService } from "app/services/root.service";
import { LanguageService } from "app/services/language.service";

declare var require: (...any) => any;
declare var Blockly: any;

@Component({
  selector: "app-blocks",
  host: {
    "(document:keyup)": "keyup($event)"
  },
  templateUrl: "./blocks.component.html",
  providers: []
})
export class BlocksComponent implements OnInit {
  //UI buttons for starting, clearing the screen and resetting
  private startBlocksButton =
    "app/img/blockIcons/xlogo/event_whenflagclicked.svg";
  private clearWorkspaceButton = "app/img/blockIcons/xlogo/remove.svg";
  private clearScreenButton = "app/img/blockIcons/xlogo/cs_2.png";

  constructor(
    private debuggerService: DebuggerService,
    private blocks: BlocksService,
    private gridService: GridService,
    private interpreterService: InterpreterService,
    private bluetoothService: BluetoothService,
    private commandsService: CommandsService,
    private canvasService: CanvasService,
    private rootRobotService: RootService
  ) {}

  startBlockExecution() {
    // read from the Blockly elements
    var [command, xml] = this.blocks.readBlocks();

    if (command !== "") {
      this.interpreterService.setInput(
        "blocks",
        command,
        () => {
          console.error("Generated commands contain errors");
        },
        () =>
          this.interpreterService.startExecution([
            new CanvasActionSet(
              this.bluetoothService,
              this.commandsService,
              this.canvasService,
              this.rootRobotService,
              this.gridService
            )
          ])
      );
      if (
        this.blocks.isClearScreenBeforeExec() ||
        this.blocks.isHistoryGray()
      ) {
        this.blocks.clearHistory();
      }
      this.blocks.moveExecBlocksToHistory(xml);
    }
  }

  clearWorkspace() {
    this.clearScreen();
    this.blocks.clearWorkspace();
  }

  clearScreen() {
    if (this.gridService.exerciseModeActive()) {
      this.gridService.resetTask();
    } else {
      this.canvasService.cs();
      CanvasComponent.canvasComponent.flush();
    }

    // clear history on next execution
    this.blocks.colorHistoryGray();
  }

  // stop working, called when user interrupts computation, in case it takes too long
  stop() {
    CanvasComponent.stop = true;
  }

  // hide the main dropdown menu
  untoggle() {
    let dropdowns = document.getElementsByClassName("dropdown-content");
    let i;
    for (i = 0; i < dropdowns.length; i++) {
      let openDropdown = dropdowns[i];
      if (openDropdown.classList.contains("show")) {
        openDropdown.classList.remove("show");
      }
    }
  }

  // check if arrow up or arrowdown are pressed
  keyup(event: KeyboardEvent) {
    // refresh workspace (displayed parameters) on enter also update command on enter
    if (this.blocks.isBlockMode()) {
      // on 'Enter'-key
      if (event.keyCode === 13) {
        //startBlocksButton()
        this.blocks.rerenderWorkspace();
      }
    }
  }

  ngOnInit() {
    // choose Toolbox for Blocks (BlueBot or Advanced)
    if (this.blocks.getMode() == 1) {
      var toolbox = this.blocks.getBlueBotToolbox(); // variant 1
    } else if (this.blocks.getMode() == 2) {
      var toolbox = this.blocks.getVariant2Toolbox(); // variant 2
    }

    // change visual appearance according to blockmode
    if (!this.blocks.isBlockMode()) {
      return;
    }

    // don't display Debugging-Switch when in BlockMode
    this.debuggerService.hideDebugFunctionality();
    // switch app container to flex-bow with flex-direction = column
    let container = document.getElementById("container");
    container.classList.add("containerBlocks");
    container.classList.remove("container");
    // unhide block buttons in header
    let startButton = document.getElementById("startExec");
    startButton.classList.remove("hidden");
    let clearWorkspace = document.getElementById("clearWorkspace");
    clearWorkspace.classList.remove("hidden");
    let csButton = document.getElementById("clearScreen");
    csButton.classList.remove("hidden");
    // change class for input component container.
    let right = document.getElementById("right");
    right.classList.add("rightBlocks");
    right.classList.remove("right");

    // setup blockly
    this.blocks.setWorkspace(
      Blockly.inject("blocklyDiv", {
        toolbox: toolbox,
        horizontalLayout: true,
        media: "app/img/blockIcons/",
        scrollbars: false,
        comments: false
      })
    );

    // generate start Flag
    this.blocks.clearWorkspace();
    this.blocks.addHistorytoExecCopyButton();

    // Event listeners for workaround to issue #1329 (https://github.com/LLK/scratch-blocks/issues/1329)
    // because Input-Field visually doesn't upadte after change
    let clickInputField = function(event) {
      if (
        event.type == Blockly.Events.BLOCK_CHANGE &&
        event.element == "field"
      ) {
        this.blocks.getWorkspace().addChangeListener(allEvents);
        this.blocks.saveWorkspace();
      }
    }.bind(this);

    let allEvents = function(event) {
      if (event.type != Blockly.Events.BLOCK_CHANGE) {
        this.blocks.getWorkspace().removeChangeListener(allEvents);
        this.blocks.loadWorkspace();
      }
    }.bind(this);

    this.blocks.getWorkspace().addChangeListener(clickInputField);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/blocks.component.ts